import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Icon } from "witmeg-ui-system";
import "./HorizontalLayout.scss"
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from "../../../../RestaurantWidget/utilities/helper/helper";
import { addToCart, deleteCartItem, getCartItemsToCartV3, updateCartItemQuantity } from "../../../../RestaurantWidget/utilities/api/restaurantsService";
import deal from "../../../assets/deal.png"
import arrow from "../../../assets/arrow-right.svg"
import check from "../../../assets/check.svg"
import arrowBlack from "../../../assets/arrow-black.svg"

import { useHistory } from 'react-router-dom';
import { addData, getAllData, setOrderCartItems, setOrderData, setOrderEmpty, setRestaurantMenuData } from '../../../../../../../../redux/resturantWidgetSlice';
import deleteIc from "../../../assets/trash.svg"
import IMAGE_PLACEHOLDER from "../../../assets/images/Images/empty-placeholder.png"
import DeletePopup from '../../Cart/DeletePopup';
import heart from "../../../assets/fvrt.svg"
import fvrt from "../../../assets/heart.svg"
import star from "../../../assets/star.svg"
import spiceImage from "../../../assets/spice.svg"
import { addItemToWishList } from '../../../../../../utilities/apiRequests/witmegRetailPaxServerRequests';
const HorizontalLayout = ({ headerText, items, showHeader }) => {
    const history = useHistory();
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")
    const [isIncreasing, setIsIncreasing] = useState(false)
    const [isDecreasing, setIsDeccreasing] = useState(false)
    const containerRef = useRef(null);
    const [showRightArrow, setShowRightArrow] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [data, setData] = useState(null)
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);
        });
    }, []);
    let categories = data ? data?.Categories : []
    let dataItems = data ? data?.Items : []

    const dispatch = useDispatch()
    const restaurantDataState = useSelector((state) => state.resturantData);
    const { currency, orderCartData,
    } = useSelector((state) => state.resturantData);
    const { companyDetails } = useSelector((state) => state.companyData);
    const currencyFormat = getCurrencyFormat(currency);
    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    useEffect(() => {
        const scrollContainer = containerRef.current;
        if (scrollContainer) {
            const handleScroll = () => {
                const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
                setShowLeftArrow(scrollLeft > 0);
                setShowRightArrow(scrollLeft + clientWidth + 20 < scrollWidth);
            };

            handleScroll();

            scrollContainer.addEventListener("scroll", handleScroll);
            window.addEventListener("resize", handleScroll);

            return () => {
                scrollContainer.removeEventListener("scroll", handleScroll);
                window.removeEventListener("resize", handleScroll);
            };
        }
    }, [items]);

    const scrollRight = () => {
        containerRef.current?.scrollBy({ left: 250, behavior: 'smooth' });
    };

    const scrollLeft = () => {
        containerRef.current?.scrollBy({ left: -250, behavior: 'smooth' });
    };
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    const getPromoPrice = (price) => {
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.Delivery;
                break;
            case "table":
                priceValue = price?.DineIn;
                break;
            default:
                priceValue = price?.Takeaway;
                break;
        }
        return "Save " + currencyFormat(priceValue / 100);
    };
    const getPromoPercentage = (PercentageValue) => {
        let value;
        switch (selectedOrderType) {
            case "delivery":
                value = PercentageValue?.Delivery;
                break;
            case "table":
                value = PercentageValue?.DineIn;
                break;
            default:
                value = PercentageValue?.Takeaway;
                break;
        }
        return value + "% OFF"
    };
    const findItemCountFromCart = (menuItem) => {
        let isAvailable = 0
        if (!orderCartData?.Items) {
            return 0
        }
        if (orderCartData?.Items?.length === 0) {
            return 0
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item?.CartItemID === menuItem?.MenuItemID)
            isAvailable = found.length
        }
        return isAvailable

    }
    const findItemFromCart = (menuItem) => {
        let isAvailable = null
        if (!orderCartData?.Items) {
            return isAvailable
        }
        if (orderCartData?.Items?.length === 0) {
            return isAvailable
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item?.CartItemID === menuItem?.MenuItemID)[0]
            isAvailable = found
        }
        return isAvailable

    }
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity) / 100),
            FormattedAmount: Number(((priceValue * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsIncreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            dispatch(setOrderData(response))
            setIsIncreasing(false)
        })
    }
    const decreaseQty = (item) => {
        setIsDeccreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                dispatch(setOrderData(response))
                setIsDeccreasing(false)

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "MENU").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    setIsDeccreasing(false)
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "") {
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "MENU").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                }
            })
        }
    }
    const handleWishlist = async (item) => {
        if (item) {
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            let category = categories?.find(cat =>
                cat.MenuEntities.some(catOBJ => catOBJ.ID === item?.MenuItemID)
            );
            let updatedItems = dataItems.map((itemval) =>
                itemval.MenuItemID === item.MenuItemID
                    ? { ...itemval, IsFavourite: !item.IsFavourite }
                    : itemval
            );

            let menu = await getAllData();
            let updated = {
                ...menu,
                data: {
                    ...menu.data,
                    Items: updatedItems
                }
            };
            await addData(updated)

            dispatch(setRestaurantMenuData({ mainMenuData: updated.data }))

            if (category) {
                let data = {
                    "ProductName": item?.Title?.en,
                    "ProductID": item?.MenuItemID,
                    "MenuID": category?.MenuID,
                    "SubMenuID": category?.MenuCategoryID,
                    "StoreID": val?.cloudLocationID,
                    "IsLikedByCustomer": !item?.IsFavourite
                }
                const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                await addItemToWishList(data, userId).then((response) => {
                    if (response) {

                    }
                })
            }
        }
    }
    const renderSpiceImages = (level) => {
        const fullImages = Math.floor((level * 2) / 2);
        const hasHalfImage = ((level * 2) % 2) !== 0;
        const images = Array.from({ length: fullImages }, (_, index) => (
            <img key={index} src={spiceImage} alt="spice-level" style={{ width: '16px' }} />
        ));
        if (hasHalfImage) {
            images.push(
                <span key="half" style={{ display: 'flex', width: '10px', overflow: 'hidden' }}>
                    <img src={spiceImage} alt="half-spice-level" style={{ width: '16px' }} />
                </span>
            );
        }

        return images;
    };
    const renderLayout = (menuItem) => {
        let isModifierAvailable = menuItem?.ModifierGroupRules?.IDs?.filter((ID) => ID !== "")?.length > 0
        const item = findItemFromCart(menuItem)
        const itemcount = findItemCountFromCart(menuItem)
        const offer = menuItem?.HasPromotions
            ? menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF") ? getPromoPrice(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "FLATOFF")?.DiscountValue) : menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF") ?
                getPromoPercentage(menuItem.ApplicablePromotions.find((promo) => promo.PromotionType === "PERCENTOFF").PercentageValue) : "" || ""
            : "";
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem?.ImageURL ? "fill" : "" }} alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                            onClick={() => {
                                history.push('/item/' + menuItem.MenuItemID + "/" + "new")
                                console.log("test")
                            }} />
                        {
                            menuItem?.HasPromotions &&
                            <div className='discount-tag'>{menuItem?.ApplicablePromotions.length > 1 ? `${menuItem?.ApplicablePromotions.length} Offers Available` : offer
                            }</div>

                        }
                        {localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' && <div className='fvrt-cont'
                            onClick={() => {
                                handleWishlist(menuItem)
                            }}
                        >
                            <img alt="" src={menuItem?.IsFavourite ? fvrt : heart} className='fvrt-icon' />
                        </div>}
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}
                        {isModifierAvailable && <div className="cart-btn-customize" onClick={() => {
                            history.push('/item/' + menuItem.MenuItemID + "/" + "new")
                        }}>
                            Customise <img alt="" src={arrow} />
                        </div>}
                        {itemcount > 0 && <div className='added-btn'>
                            <img alt="" src={check} />
                            {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}  - Added to cart
                        </div>}
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className='mob-name'><div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                            </div>
                                {itemcount > 0 && <div className='added-btn-mob'>
                                    {isModifierAvailable ? itemcount : (item?.Quantity.Amount || 0)}
                                </div>}
                            </div>
                            <div className="price">
                                {menuItem?.HasPromotions ?
                                    menuItem?.ApplicablePromotions[0] ? getThePrice(menuItem?.ApplicablePromotions[0]?.DiscountedPrices) : ""
                                    : getThePrice(menuItem?.PriceInfo?.Price)}
                                <div className='old-price-val'>{menuItem?.HasPromotions ?
                                    getThePrice(menuItem?.PriceInfo?.Price) : ""}</div>
                            </div>
                        </div>
                        <div className='det-cont-wrap'>
                            <div className='dev-left'>
                                <div className='review-cont'>
                                    <img alt='' className='rev-star' src={star} />
                                    <div className='revi-per'>{menuItem?.AggregatedProductRating}</div>
                                    <div className='rev-count'>({menuItem?.TotalReviews})</div>
                                </div>
                                {menuItem?.DishInfo?.Classifications?.SpiceLevel > 0 && <div className="spice-leve-img">{renderSpiceImages(menuItem?.DishInfo.Classifications.SpiceLevel)}</div>}

                            </div>
                            <div className='dev-right'>
                                {menuItem?.DishInfo?.Classifications?.IsVegetarian && <div className="spe-cont">Vegetarian</div>}
                                {menuItem?.DishInfo?.Classifications?.IsHalal && <div className="spe-cont">Halal</div>}

                            </div>
                        </div>
                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                        <div className="price-container">
                            <div className="price">
                                {menuItem?.HasPromotions ?
                                    menuItem?.ApplicablePromotions[0] ? getThePrice(menuItem?.ApplicablePromotions[0]?.DiscountedPrices) : ""
                                    : getThePrice(menuItem?.PriceInfo?.Price)}
                                <div className='old-price-val'>{menuItem?.HasPromotions ?
                                    getThePrice(menuItem?.PriceInfo?.Price) : ""}</div>
                            </div>
                            {itemcount > 0 && !isModifierAvailable ?
                                <div className="quantity">
                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            decreaseQty(item)
                                        }
                                    }}>
                                        {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                    </div>
                                    <div className="qty-cont">
                                        {item?.Quantity.Amount || 0}
                                    </div>

                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            increaseQty(item)
                                        }
                                    }}>
                                        <Icon name="plus" className="icon" />
                                    </div>
                                </div> : <div className="add-to-cart-btn" onClick={() => {
                                    if (isLoading !== menuItem?.MenuItemID) {
                                        if (isModifierAvailable) {
                                            history.push('/item/' + menuItem.MenuItemID + "/" + "new")
                                        } else {
                                            addItemToCart(menuItem)
                                        }
                                    }
                                }}>{isLoading === menuItem?.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}
                            {isModifierAvailable && <div className="add-to-cart-btn-custom" onClick={() => {
                                history.push('/item/' + menuItem.MenuItemID + "/" + "new")
                            }}>
                                Customise
                            </div>}
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: "GB"
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const addItemToCart = async (selectedItem) => {
        setIsLoading(selectedItem.MenuItemID)
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        const userDetails = localStorage.getItem('fullUserDetails')
        let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
        let customer = {
            ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            Name: {
                DisplayName: userDetails ? parsedUserDetails.UserName : "",
                FirstName: userDetails ? parsedUserDetails.FirstName : "",
                LastName: userDetails ? parsedUserDetails.LastName : "",
            },
            Email: userDetails ? parsedUserDetails.Email : "",
            IsPrimaryCustomer: true

        }
        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        let cartObject = {
            "CartItemID": selectedItem.MenuItemID,
            "Title": selectedItem.Title?.en,
            "CustomerID": customerID,
            "Quantity": {
                "Unit": "pcs",
                "Amount": 1
            },
            "DefaultQuantity": {
                "Amount": 1,
                "Unit": "pcs"
            },
            "CustomerRequests": {
                "Allergy": {
                    "Allergens": [],
                    "Instructions": ""
                },
                "SpecialInstructions": ""
            },
            SelectedModifierGroups: [],
            ValueID: uuidv4(),
            ID: "",
            ModifierGroupRules: selectedItem.ModifierGroupRules,
            Image: selectedItem.ImageURL,
            PriceInfo: getItemPriceForCart(selectedItem.PriceInfo, 1)

        }
        let cart = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
            "StoreID": val.cloudLocationID,
            "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            "OrderingPlatformType": "RETAILPACX",
            "CountryISOCode": "GB",
            "OrganizationID": val.organizationID,
            "CloudLocationID": val.cloudLocationID,
            "Name": companyDetails.shopName,
            "OrderFullFilmentType": getOrderType(),
            "Customers": [customer],
            Cart: cartObject,
            OrderType: "MENU"
        }
        await addToCart(cart).then((res) => {
            if (res) {
                getCartItemsToCartV3(customerID, val.cloudLocationID, "MENU").then((response) => {
                    if (response) {
                        dispatch(setOrderData(response))
                        setIsLoading("")

                    }
                })
            }
        })
    }
    return (
        <div className="Hospitality-Horizontal-Layout-Menu">
            {showHeader && <div className='textheader-container'>
                <div className="title-menu-2" >{headerText || ""}</div>
                <div className='arr-conta'>

                    {(showLeftArrow || showRightArrow) && <>
                        <div
                            onClick={scrollLeft}
                            className={`arrow-left ${!showLeftArrow ? "disabled" : ""}`}
                        >
                            <img alt="" src={arrowBlack} />

                        </div>

                        <div
                            onClick={scrollRight}
                            className={`arrow-right ${!showRightArrow ? "disabled" : ""}`}
                        >
                            <img alt="" src={arrowBlack} />

                        </div> </>}
                </div>
            </div>}
            <div className="layout4" ref={containerRef}>
                {items.map(((menuItem, key) => {
                    return (
                        <div className="column-styles" key={key}>
                            {renderLayout(menuItem)}
                        </div>
                    )
                }))}
            </div>
            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem} />
        </div >
    )
}
export default HorizontalLayout